import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scroll from "vue3-seamless-scroll";

// Element Plus UI library（样式需先于项目全局样式加载，
// 以便我们的覆盖规则在同特异性下靠后生效、稳定胜出）
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Global base styles
import '@/styles/init.css'

// Global theme styles
import '@/styles/theme.scss'

// Rem-based responsive scaling
import "amfe-flexible/index"

// Lazy-load directive for images
import Lazyload from "vue3-lazyload";

createApp(App).use(store).use(router).use(ElementPlus).use(Lazyload).use(scroll).mount('#app')
